import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-[#87CEEB] sticky top-0 z-40 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-white hover:text-white/80">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-lg font-semibold text-white">Privacy Policy</h1>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Privacy Policy</h1>
          <p className="text-slate-500 mb-8">Last updated: December 2024</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">1. Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Account information (name, email, phone number)</li>
              <li>Profile information (NDIS number for participants, qualifications for workers)</li>
              <li>Booking and payment information</li>
              <li>Messages and communications through our platform</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Process bookings and payments</li>
              <li>Send you notifications about your bookings</li>
              <li>Connect participants with suitable support workers</li>
              <li>Respond to your requests and inquiries</li>
              <li>Ensure the safety and security of our platform</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">3. Information Sharing</h2>
            <p className="text-slate-600 mb-4">
              We may share your information with:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Support workers (for participants) or participants (for workers) to facilitate services</li>
              <li>Payment processors to complete transactions</li>
              <li>Service providers who assist in our operations</li>
              <li>Law enforcement when required by law</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">4. Data Security</h2>
            <p className="text-slate-600 mb-4">
              We implement appropriate security measures to protect your personal information, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Encryption of data in transit and at rest</li>
              <li>Secure authentication mechanisms</li>
              <li>Regular security assessments</li>
              <li>Access controls and monitoring</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">5. Your Rights</h2>
            <p className="text-slate-600 mb-4">
              Under Australian Privacy Law, you have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with the OAIC</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">6. Cookies and Tracking</h2>
            <p className="text-slate-600 mb-4">
              We use cookies and similar technologies to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Keep you logged in</li>
              <li>Remember your preferences</li>
              <li>Analyze how our service is used</li>
              <li>Improve our services</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">7. NDIS Information</h2>
            <p className="text-slate-600 mb-4">
              We handle NDIS-related information with extra care and in compliance with NDIS 
              requirements. Your NDIS number and related information is only used to verify 
              your participant status and is not shared without your consent.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">8. Data Retention</h2>
            <p className="text-slate-600 mb-4">
              We retain your information for as long as your account is active or as needed to 
              provide services. We may retain certain information as required by law or for 
              legitimate business purposes.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">9. Changes to This Policy</h2>
            <p className="text-slate-600 mb-4">
              We may update this privacy policy from time to time. We will notify you of any 
              changes by posting the new policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-6 mb-3">10. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have any questions about this Privacy Policy, please contact us at{" "}
              <a href="mailto:privacy@btrhealth.com" className="text-[#87CEEB] hover:underline">
                privacy@btrhealth.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
